import {
  ALARM_PAGE_GET_DATA,
  ALARM_PAGE_GET_DETAILS_DATA,
  ALARM_PAGE_UPDATE_DATA,
} from "./Constants";

// Get all alarm page listing
const loadAlarmPageDataRequest = () => ({
  type: ALARM_PAGE_GET_DATA.ALARM_PAGE_GET_DATA_LOAD,
});
const setAlarmPageDataSuccess = (alarmPageList) => ({
  type: ALARM_PAGE_GET_DATA.ALARM_PAGE_GET_DATA_SUCCESS,
  alarmPageList,
});
const setAlarmPageDataFail = (error) => ({
  type: ALARM_PAGE_GET_DATA.ALARM_PAGE_GET_DATA_FAIL,
  error,
});

// Get by id
const loadAlarmPageGetDetailsRequest = (id) => ({
  type: ALARM_PAGE_GET_DETAILS_DATA.ALARM_PAGE_GET_DETAILS_DATA_LOAD,
  id,
});
const setAlarmPageGetDetailsSuccess = (alarmPage) => ({
  type: ALARM_PAGE_GET_DETAILS_DATA.ALARM_PAGE_GET_DETAILS_DATA_SUCCESS,
  alarmPage,
});
const setAlarmPageGetDetailsFail = (error) => ({
  type: ALARM_PAGE_GET_DETAILS_DATA.ALARM_PAGE_GET_DETAILS_DATA_FAIL,
  error,
});

// Update
const loadAlarmPageUpdateDataRequest = (request) => ({
  type: ALARM_PAGE_UPDATE_DATA.ALARM_PAGE_UPDATE_DATA_LOAD,
  request,
});
const setAlarmPageUpdateDataSuccess = (alarmPage) => ({
  type: ALARM_PAGE_UPDATE_DATA.ALARM_PAGE_UPDATE_DATA_SUCCESS,
  alarmPage,
});
const setAlarmPageUpdateDataFail = (error) => ({
  type: ALARM_PAGE_UPDATE_DATA.ALARM_PAGE_UPDATE_DATA_FAIL,
  error,
});
const resetAlarmPageUpdateData = () => ({
  type: ALARM_PAGE_UPDATE_DATA.ALARM_PAGE_UPDATE_DATA_RESET,
});

export {
  loadAlarmPageDataRequest, setAlarmPageDataSuccess, setAlarmPageDataFail,
  loadAlarmPageGetDetailsRequest, setAlarmPageGetDetailsSuccess, setAlarmPageGetDetailsFail,
  loadAlarmPageUpdateDataRequest, setAlarmPageUpdateDataSuccess, setAlarmPageUpdateDataFail, resetAlarmPageUpdateData,
};